// extracted by mini-css-extract-plugin
export default {"box":"TopicsList_box__jvfbx","list":"TopicsList_list__RjgdG","dragArea":"TopicsList_dragArea__8vuOV"};